import { useQueryClient } from "@tanstack/react-query";
import { editHospitalityListing } from "../../api";
import { EditHospitalityListingDTO } from "../../dtos";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useEditHospitalityListing() {
  const queryClient = useQueryClient();

  return useDomainMutation<
    AxiosResponse,
    { response?: { data?: { message?: string } } },
    { uid: string; data: EditHospitalityListingDTO }
  >({
    mutationFn: ({ uid, data }: { uid: string; data: EditHospitalityListingDTO }) =>
      editHospitalityListing(uid, data),
    onSuccess: (_, { data: mutatedData }) => {
      queryClient.invalidateQueries({ queryKey: ["hospitality-listings"] });
      if (mutatedData) queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });
}
